import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@xingternal/button';
import { IconArrowLeft } from '@xingternal/icons';

import styles from './BackLink.css';

const BackLink = ({ label, onClose, to }) => (
  <div className={styles.wrapper}>
    <Button
      variant="text"
      size="small"
      to={to}
      onClick={onClose}
      icon={IconArrowLeft}
    >
      {label}
    </Button>
  </div>
);

BackLink.displayName = 'BackLink';

BackLink.propTypes = {
  label: PropTypes.string,
  onClose: PropTypes.func,
  to: PropTypes.string,
};

export { BackLink };
